/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { SIDEBAR_WIDTH } from "./Sidebar"
import { useMediaQuery } from "@cd2/components"

export function FloatingBottomActions({ children }: { children: React.ReactNode }) {
  const isSmall = useMediaQuery({ maxWidth: 850 })
  return (
    <React.Fragment>
      <div
        css={css`
          position: fixed;
          bottom: 0;
          left: ${isSmall ? 0 : SIDEBAR_WIDTH}px;
          padding: 16px;
          border-top: 1px solid #dadada;
          background-color: #fff;
          z-index: 2;
          width: calc(100% - ${isSmall ? 0 : SIDEBAR_WIDTH}px);
          box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 12px;
        `}
      >
        {children}
      </div>
    </React.Fragment>
  )
}
